import { render, staticRenderFns } from "./StoryAuthorSelector.vue?vue&type=template&id=c9535d3c&scoped=true&"
import script from "./StoryAuthorSelector.vue?vue&type=script&lang=js&"
export * from "./StoryAuthorSelector.vue?vue&type=script&lang=js&"
import style0 from "./StoryAuthorSelector.vue?vue&type=style&index=0&id=c9535d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9535d3c",
  null
  
)

export default component.exports